module.exports = __webpack_public_path__ + "static/media/slider-plain-1.8c7d2266.jpg";